import React from "react";

const TalesOfStartupsDetails = () => {
  return <div>TalesOfStartupsDetails</div>;
};

export default TalesOfStartupsDetails;
